/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__organization_invitation__model__SortByColumnEnum;

(function (jove__app__organization_invitation__model__SortByColumnEnum) {
  jove__app__organization_invitation__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__organization_invitation__model__SortByColumnEnum["ORGANIZATION_ID"] = "organization_id";
  jove__app__organization_invitation__model__SortByColumnEnum["STATUS"] = "status";
  jove__app__organization_invitation__model__SortByColumnEnum["USER_ID"] = "user_id";
  jove__app__organization_invitation__model__SortByColumnEnum["EMAIL"] = "email";
})(jove__app__organization_invitation__model__SortByColumnEnum || (jove__app__organization_invitation__model__SortByColumnEnum = {}));